import { ReservaPolicy } from "./ReservaPolicy"

export const reservaPolicy = new ReservaPolicy()